// Angular
import { Component } from '@angular/core';

// Angular Material
import { MatDialog } from '@angular/material/dialog';

// services
import { DrawerService } from '@app/services/drawer/drawer.service';
import { ApiService } from '@app/services/api/api.service';

@Component({
  selector: 'oh-confirm-logout',
  templateUrl: './confirm-logout.component.html',
  styleUrls: ['./confirm-logout.component.scss'],
})
export class ConfirmLogoutComponent {
  constructor(private dialog: MatDialog, private drawerService: DrawerService, private apiService: ApiService) {}

  public async logout() {
    await this.apiService.clearDatabase();
    location.reload();
  }

  public cancel() {
    this.dialog.closeAll();
  }
}
